import React from 'react';
import ContainerPage from '../../../../components/ContainerPage';
import HeadTitle from '../../../../components/HeadTitle';

import * as S from './styles';
import { Button } from '../../../../components';
import { useRouter } from '../../../../contexts/RouterContext';
import Radio from '../../../../components/Radio';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { PAGES } from '../../../../Router/pages';
import { CREATE_SCHEDULE_APPOINTMENTS_TYPES } from '../../../../utils/enums/appointment-types';
import TagInfo from '../../../../components/TagInfo';
import { TagInfoWarningIcon } from '../../../../components/TagInfoWarningIcon';

const AppointmentTypeSpecialist: React.FC = () => {
  const router = useRouter();
  const scheduler = useScheduleContext();

  const returnTime = scheduler.scheduleSpecialistSelected.return_time;

  const [appointmentStatus, setAppointmentStatus] = React.useState<{
    isNewAppointment?: boolean;
    isReturn?: boolean;
  }>();

  function toggleIsNewAppointment(isNewAppointment: boolean) {
    setAppointmentStatus({ isNewAppointment: isNewAppointment });
  }

  function toggleIsReturn(isReturn: boolean) {
    setAppointmentStatus({ ...appointmentStatus, isReturn: isReturn });
  }

  function isButtonDisable() {
    if (appointmentStatus?.isNewAppointment === false) return false;
    if (appointmentStatus?.isNewAppointment === true)
      if (appointmentStatus.isReturn === true || appointmentStatus.isReturn === false) return false;
    return true;
  }

  function handleContinue() {
    let appointmentType = '';

    if (!appointmentStatus?.isNewAppointment) appointmentType = CREATE_SCHEDULE_APPOINTMENTS_TYPES.FIRST_APPOINTMENT;

    if (appointmentStatus?.isNewAppointment) {
      if (appointmentStatus?.isReturn) appointmentType = CREATE_SCHEDULE_APPOINTMENTS_TYPES.RETURN;
      else appointmentType = CREATE_SCHEDULE_APPOINTMENTS_TYPES.NEW_APPOINTMENT;
    }

    let catalog = { name: 'Consulta médica' };

    if (appointmentType === CREATE_SCHEDULE_APPOINTMENTS_TYPES.FIRST_APPOINTMENT)
      catalog = { name: 'Primeira consulta' };
    if (appointmentType === CREATE_SCHEDULE_APPOINTMENTS_TYPES.RETURN) catalog = { name: 'Consulta de retorno' };

    scheduler.setScheduleSpecialistSelected({
      ...scheduler.scheduleSpecialistSelected,
      appointmentType,
      catalog
    });

    router.goTo(PAGES.SERVICE_UNIT.id);
  }

  return (
    <ContainerPage childrenFooter={<Button disabled={isButtonDisable()} onClick={handleContinue} title="Continuar" />}>
      <HeadTitle title="Precisamos de mais algumas informações" goBack={router.goBack} />
      <S.Container>
        <S.Info>Você já se consultou com esse(a) médico(a) anteriormente?</S.Info>
        <S.OptionsWrapper>
          <S.Option isSelected={!!appointmentStatus?.isNewAppointment} onClick={() => toggleIsNewAppointment(true)}>
            <S.LabelOption>Sim</S.LabelOption>
            <Radio isChecked={!!appointmentStatus?.isNewAppointment} />
          </S.Option>
          <S.Option
            isSelected={appointmentStatus?.isNewAppointment === false}
            onClick={() => toggleIsNewAppointment(false)}
          >
            <S.LabelOption>Não</S.LabelOption>
            <Radio isChecked={appointmentStatus?.isNewAppointment === false} />
          </S.Option>
        </S.OptionsWrapper>

        {appointmentStatus?.isNewAppointment && (
          <>
            <S.Info>Essa é uma consulta de retorno?</S.Info>
            <S.OptionsWrapper>
              <S.Option isSelected={appointmentStatus?.isReturn === true} onClick={() => toggleIsReturn(true)}>
                <S.LabelOption>Sim</S.LabelOption>
                <Radio isChecked={appointmentStatus?.isReturn === true} />
              </S.Option>
              <S.Option isSelected={appointmentStatus?.isReturn === false} onClick={() => toggleIsReturn(false)}>
                <S.LabelOption>Não</S.LabelOption>
                <Radio isChecked={appointmentStatus?.isReturn === false} />
              </S.Option>
            </S.OptionsWrapper>
            {returnTime && (
              <TagInfo
                icon={<TagInfoWarningIcon />}
                type="WARNING"
                info={`Consultas de retorno podem ser realizadas em até ${returnTime} dias após a realização da primeira consulta.`}
              />
            )}
          </>
        )}
      </S.Container>
    </ContainerPage>
  );
};

export default AppointmentTypeSpecialist;
